import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	FlatRowRadioGroup,
	type FlatRowRadioOption,
} from "web_myplann/Shared/Components/FlatRow/FlatRowRadioGroup";

type Props<
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TValue extends string | number,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	options: FlatRowRadioOption<TValue>[];
};

export const FlatRowFormRadio = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TValue extends string | number = string,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	options,
}: Props<FormType, TName, TValue, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange, onBlur } }) => (
			<FlatRowRadioGroup<TValue>
				value={value as TValue}
				options={options}
				onChange={onChange}
				onBlur={onBlur}
			/>
		)}
	/>
);
